import { useMemo } from 'react';
import { cn } from '@/lib/utils';

/** Build a full SVG document string from a toolpath `d`. Rendered as a blob URL
 * inside an `<img>` — same isolation model as `SvgViewer`, and the only way to
 * avoid inline-SVG CSS bleed and clipping across all browsers. */
function toolpathSvg(d: string, stroke: string, width: number): string {
  return `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 100 75" width="400" height="300"><rect width="100" height="75" fill="transparent"/><path d="${d}" fill="none" stroke="${stroke}" stroke-width="${width}" stroke-linecap="round" stroke-linejoin="round" vector-effect="non-scaling-stroke"/></svg>`;
}

/** The real cutting path, as read from a file's G-code. Blob SVGs have no CSS
 * context, so `stroke` has to be a concrete colour, not a token. */
export default function ToolpathPreview({
  d,
  stroke = '#136245',
  strokeWidth = 1.2,
  className,
}: {
  d: string;
  stroke?: string;
  strokeWidth?: number;
  className?: string;
}) {
  // One blob per toolpath — stable for the card's lifetime, no re-render churn.
  const url = useMemo(() => {
    const blob = new Blob([toolpathSvg(d, stroke, strokeWidth)], {
      type: 'image/svg+xml',
    });
    return URL.createObjectURL(blob);
  }, [d, stroke, strokeWidth]);

  return (
    <img
      src={url}
      alt="toolpath preview"
      className={cn('h-full w-full object-contain', className)}
    />
  );
}
